import { fetchUserInfo } from '@/modules/authentication/authApi'
import { getAccessToken } from '@/services/localStorage'
import { useQuery } from '@tanstack/vue-query'
import { acceptHMRUpdate, defineStore } from 'pinia'
import { computed, watch } from 'vue'

export const useAuth = defineStore('currentUserStore', () => {
  const token = computed(() => getAccessToken())

  const { data: userData, isLoading, refetch: getUserInfo } = useQuery({
    queryKey: ['user', token.value],
    queryFn: fetchUserInfo,
    enabled: () => !!token.value,
  })

  const user = computed(() => userData.value)
  const authorities = computed(() => new Set(user.value?.rights ?? []))
  const isAuthorize = (menuAuthorities?: readonly number[] | null) => {
    if (!menuAuthorities) return true
    if (user.value?.isAdmin) return true
    if (!authorities.value?.size) return false
    return menuAuthorities.every(authority => authorities.value!.has(authority))
  }
  const isAdmin = computed(() => user.value?.isAdmin)
  const tokenComputed = computed(() => getAccessToken())

  let resolveAuth: () => void
  const authLoaded = new Promise<void>(resolve => resolveAuth = resolve)

  watch(isLoading, (loading) => {
    if (loading) return
    resolveAuth()
  }, { immediate: true })

  watch(token, () => {
    if (!token.value) return
    getUserInfo()
  })

  return {
    user,
    isLoading,
    authorities,
    isAuthorize,
    token: tokenComputed,
    isAdmin,
    authLoaded,
    getUserInfo,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAuth, import.meta.hot))
}
